export default (items, match) => {
  const matcher = typeof(match) === 'function' ? match : (item) => item[match];

  return items.reduce(
    (result, item) => {
      const key = matcher(item);
      return {
        ...result,
        [key]: [
          ...(result[key] || []),
          item
        ]
      }
    },
    {}
  );
};